/* =========================================================================
   variant-swatches.js — Flag "Esgotado" ao lado do tamanho selecionado.

   Mostra/esconde a etiqueta [data-soldout-flag] conforme o valor selecionado
   da opção está indisponível. Reaproveita o estado do próprio tema: o
   variant-picker marca `.is-disabled` no swatch (label) de cada valor sem
   estoque. Se o input marcado (:checked) tem o label com `.is-disabled`, a
   seleção atual está esgotada -> mostra a flag.
   ========================================================================= */
(function () {
  if (window.__variantSoldoutFlags) return;
  window.__variantSoldoutFlags = true;

  function refresh(picker) {
    var options = picker.querySelectorAll('.variant-picker__option');
    for (var i = 0; i < options.length; i++) {
      var flag = options[i].querySelector('[data-soldout-flag]');
      if (!flag) continue;
      var checked = options[i].querySelector('input[name^="option"]:checked');
      var soldout = false;
      if (checked) {
        var label = checked.nextElementSibling;
        if (label && label.classList && label.classList.contains('is-disabled')) {
          soldout = true;
        }
      }
      flag.hidden = !soldout;
    }
  }

  function init(picker) {
    if (picker.__soldoutInit) return;
    picker.__soldoutInit = true;
    refresh(picker);
    picker.addEventListener('change', function () { refresh(picker); });
    // O tema alterna `.is-disabled` de forma assíncrona quando outra opção muda.
    var observer = new MutationObserver(function () { refresh(picker); });
    observer.observe(picker, {
      subtree: true,
      attributes: true,
      attributeFilter: ['class'],
    });
  }

  function boot(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var pickers = scope.querySelectorAll('variant-picker');
    for (var i = 0; i < pickers.length; i++) init(pickers[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  // Seções recarregadas no editor de tema.
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });

  // Pickers inseridos dinamicamente (quick-buy drawer, etc.).
  if (window.MutationObserver && document.body) {
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          if (node.matches && node.matches('variant-picker')) init(node);
          else boot(node);
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
